/* Option Price Suffix — Stern Performance
 * Trennt im ShopPad-Swatchlabel den Aufpreis-Klammertext (z.B. "(+ 45 €)") in
 * ein eigenes <span class="sp-price-suffix"> ab, sodass per CSS display:block
 * der Aufpreis IMMER auf eigener Zeile unter dem Farbnamen steht.
 *
 * Normalisiert Schreibweisen: "Vollcarbon +45 €)" und "Royalrot (+ 50 €)"
 * werden beide zu "Royalrot" + "(+ 45 €)".
 */
(function () {
  'use strict';

  // Matcht: "(+ 45 €)", "+45 €)", " +45 €", "(+50€)" am Ende des Labels
  var PRICE_REGEX = /[\s\(]\+\s*(\d+)\s*€\s*\)?\s*$/;

  function processLabel(label) {
    if (label.dataset.priceSplit === 'true') return;
    label.dataset.priceSplit = 'true';

    var text = (label.textContent || '').trim();
    var match = text.match(PRICE_REGEX);
    if (!match) return;

    var amount = match[1];
    var matchStart = text.search(PRICE_REGEX);
    var name = text.slice(0, matchStart).trim();
    // Falls am Ende des Namens eine offene "(" hängt (Tippfehler-Variants), abschneiden
    name = name.replace(/\s*\(\s*$/, '').trim();

    label.textContent = '';
    label.appendChild(document.createTextNode(name));
    var suffix = document.createElement('span');
    suffix.className = 'sp-price-suffix';
    suffix.textContent = '(+ ' + amount + ' €)';
    label.appendChild(suffix);
  }

  function scanAll(root) {
    var labels = (root || document).querySelectorAll('.spb-swatchlabel');
    for (var i = 0; i < labels.length; i++) processLabel(labels[i]);
  }

  function init() {
    var container = document.getElementById('infiniteoptions-container');
    if (!container) return false;

    scanAll(container);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scanAll(added[j]);
        }
      }
    }).observe(container, { childList: true, subtree: true });
    return true;
  }

  function bootstrap() {
    if (init()) return;
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (init() || attempts > 40) clearInterval(poll);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
